import { jarallax, jarallaxVideo } from "jarallax";

jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.2,
    imgPosition: "50% 90px"
});